import { array, string, object } from 'yup'

export const CreateModalSchema = object().shape({
	bin: string().required({ key: 'required' }),
	categoryCode: string().required({ key: 'required' }),
	email: string().required({ key: 'required' }),
	katoAB: string().required({ key: 'required' }),
	okedCode: string().required({ key: 'required' }),
	mobilePhone: string().required({ key: 'required' }),
	nominationCode: string().required({ key: 'required' }),
	orgName: string().required({ key: 'required' }),
	workPhone: string().required({ key: 'required' }),
	directorFullName: string().required({ key: 'required' }),
	foundationDate: string().required({ key: 'required' }),
	paramValues: array().of(
		object({
			numValue: string().nullable(),
			dictValue: string().nullable(),
			textValue: string().nullable(),
		})
			.nullable()
			.test(
			'only-one-required',
			'',
			function (value) {
				if (!value) return true;

				const keys = ['numValue', 'dictValue', 'textValue'];
				const presentKey = keys.find(k => Object.prototype.hasOwnProperty.call(value, k));
				if (!presentKey) return true;
				if (value[presentKey] === null || value[presentKey] === '') {
					return this.createError({
						path: `${this.path}.${presentKey}`,
						message: { key: 'required' },
					});
				}
				return true;
			}
		),
	),
});